import moment from "moment";

export const CHART_TOOLTIPS: Record<string, string> = {
    avgResQualityChart: "This chart displays the overall response quality given a custom timeframe. It helps identify the general trends of query activities and response quality.",
    improvementChart: "This chart shows the improvements of response quality in underperforming areas during a custom timeframe. It helps validate the effectiveness of implemented solutions and guide further adjustments.",
    eventFrequencyChart: "This chart shows the distribution of queries in areas in a custom timeframe. It helps understand what areas are popular and most frequently in use."
}

export const AVG_RESPONSE_QUALITY_CHART_COLOR: string = '#5654D4';
export const IMPROVEMENT_CHART_COLORS: string[] = ['#5654D4', '#3FC8E4', '#FB3B52', '#15CEC2', '#ed6fb7'];
export const EVENT_FREQUENCY_CHART_COLORS: string[] = ['#0EA5E9', '#FF9F0A', '#FFC90A', '#15CEC2','#FD6C78'];

export const EVENTS_BREADCRUMB_TITLE = 'Events';

export const DEFAULT_DATE_RANGE = {
    startDate:  moment(new Date()).subtract(179, 'days').format('YYYY-MM-DD'),
    endDate: moment(new Date()).format('YYYY-MM-DD'),
};